import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Errors, FormBase, Optional, Required, ValidationLimits, Validators, number } from '@sb/library/base';
import { FormFieldSubformBaseComponent } from '../../../form-field-subform-base.component';

class DurationForm extends FormBase {
    Hours = Optional(number);
    Minutes = Required(number);
    Seconds = Required(number);
}

@Component({
    selector: 'lib-input-duration',
    templateUrl: './form-field-duration.component.html',
    styleUrls: ['./form-field-duration.component.scss']
})
export class FormFieldDurationComponent extends FormFieldSubformBaseComponent<number | null, DurationForm> implements OnInit, OnDestroy, AfterViewInit {

    readonly form = DurationForm.Create(false);

    @Input() showHoursField: boolean = false;
    @Input() showSecondsField: boolean = true;
    @Input() isOptional: boolean = false;

    constructor() {
        super();
        this.errors.Override({
            subform: () => {
                for (const control of Object.values(this.form.controls)) {
                    if (control.errors) {
                        return new Errors().GetMessage(control.errors) ?? '';
                    }
                }
                return '';
            }
        });
    }

    writeFormValue(value: number | null): void {
        if (value !== null) {
            this.PatchForm(value);
        }
    }

    ngAfterViewInit() {
        if (this.showHoursField) {
            this.form.controls.Minutes.AddValidators(Validators.max(59));
            this.form.controls.Hours.AddValidators(Validators.max(ValidationLimits.Numbers.Duration.Hours));
        } else {
            this.form.controls.Minutes.AddValidators(Validators.max(ValidationLimits.Numbers.Duration.Minutes));
        }
        
        this.form.controls.Seconds.AddValidators(Validators.max(59));

        this.PatchForm(this.formControl.value ?? 0);
    }

    FocusOut(): void {
        this.PatchForm(this.formControl.value ?? 0);
    }

    PatchForm(duration: number): void {
        const hours = this.showHoursField ? Math.floor(duration / 3600) : 0;
        const mins = this.showHoursField ? Math.floor((duration % 3600) / 60) : Math.floor((duration / 60));
        const secs = this.showSecondsField ? Math.floor((duration % 3600) % 60) : 0;

        setTimeout(() => {
            this.form.patchValue({
                Hours: hours,
                Minutes: mins,
                Seconds: secs,
            });

            this.formControl.updateValueAndValidity();
            this.change.emit(this.CalculateDuration(hours!, this.form.controls.Minutes.value!, this.form.controls.Seconds.value!));
        });
    }

    HoursChanged(hours: number | null) {
        this.formControl.setValue(this.CalculateDuration(hours!, this.form.controls.Minutes.value!, this.form.controls.Seconds.value!));
    }

    MinutesChanged(minutes: number | null) {
        this.formControl.setValue(this.CalculateDuration(this.form.controls.Hours.value!, minutes!, this.form.controls.Seconds.value!));
        if (minutes! > 59 && this.showHoursField) {
            this.PatchForm(this.formControl.value!);
        }
    }

    SecondsChanged(seconds: number | null) {
        this.formControl.setValue(this.CalculateDuration(this.form.controls.Hours.value!, this.form.controls.Minutes.value!, seconds!));
        if (seconds! > 59) {
            this.PatchForm(this.formControl.value!)
        }
    }

    CalculateDuration(hours: number = 0, minutes: number = 0, seconds: number = 0): number {
        return hours * 3600 + minutes * 60 + seconds;
    }
}
